/* eslint-disable */
let appConfig = {
	yamapsUrl: 'https://api-maps.yandex.ru/2.1/?apikey=fd21f65c-506d-45d8-9cfe-18c5ad8d4173&lang=ru_RU',
	marketingClientConfig: {
		apiGatewayUrl: window.appConfig?.apiGatewayUrl,
	}
};

export default appConfig;